var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVaskBuss(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6223 16.3909C17.2824 18.7639 11.6798 18.7691 8.3775 16.4014L8.37488 12.6879H20.6249L20.6223 16.3909ZM20.6249 22.1221H18.4103V21.5079C18.4103 21.0564 18.6553 20.6486 19.0359 20.4684L20.6249 19.7141V22.1221ZM10.5895 22.1221H8.37488V19.7132L9.96475 20.4684C10.3445 20.6486 10.5895 21.0572 10.5895 21.5079V22.1221ZM22.7188 12.6879H21.4999V11.5329C21.4999 10.4452 20.6923 9.62537 19.6213 9.62537H9.37763C8.3075 9.62537 7.49988 10.4452 7.49988 11.5329V12.6879H6.28013C5.98788 12.6879 5.74988 12.9407 5.74988 13.2531V15.5474C5.74988 16.383 6.42888 17.0629 7.2645 17.0629H7.49988V23.5431C7.49988 23.5501 7.50075 23.5554 7.50075 23.5615L7.58125 25.6606C7.59263 25.9914 7.86213 26.2504 8.19288 26.2504H11.0935C11.4085 26.2504 11.6701 26.0036 11.6885 25.6939L11.7708 24.5004H17.2299L17.3113 25.6904C17.3296 26.0036 17.5913 26.2504 17.9063 26.2504H20.8069C21.1376 26.2504 21.4063 25.9914 21.4176 25.6667L21.4999 23.5431V17.0629H21.7344C22.5709 17.0629 23.2499 16.383 23.2499 15.5474V13.2531C23.2499 12.9407 23.011 12.6879 22.7188 12.6879Z",
    fill: "#2B2B2C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9166 10.9028L27 12.2917",
    stroke: "#2B2B2C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9166 19.2362L27 20.6251",
    stroke: "#2B2B2C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9166 20.6251L27 22.014",
    stroke: "#2B2B2C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9166 12.2917L27 13.6806",
    stroke: "#2B2B2C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9166 13.6807L27 15.0696",
    stroke: "#2B2B2C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9166 15.0696L27 16.4585",
    stroke: "#2B2B2C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9166 16.4585L27 17.8474",
    stroke: "#2B2B2C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9166 17.8473L27 19.2362",
    stroke: "#2B2B2C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9583 9.51398V6.04175H20.0555",
    stroke: "#2B2B2C",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M2 10.9028L4.08334 12.2917",
    stroke: "#2B2B2C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2 19.2362L4.08334 20.6251",
    stroke: "#2B2B2C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2 20.6251L4.08334 22.014",
    stroke: "#2B2B2C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12.2917L4.08334 13.6806",
    stroke: "#2B2B2C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M2 13.6807L4.08334 15.0696",
    stroke: "#2B2B2C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2 15.0696L4.08334 16.4585",
    stroke: "#2B2B2C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2 16.4585L4.08334 17.8474",
    stroke: "#2B2B2C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M2 17.8473L4.08334 19.2362",
    stroke: "#2B2B2C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M3.04166 9.51398V6.04175H8.94446",
    stroke: "#2B2B2C",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 7.08325L11.7221 4.99991",
    stroke: "#2B2B2C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7222 7.08325L13.1111 4.99991",
    stroke: "#2B2B2C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1111 7.08325L14.5 4.99991",
    stroke: "#2B2B2C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 7.08325L15.8889 4.99991",
    stroke: "#2B2B2C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8888 7.08325L17.2777 4.99991",
    stroke: "#2B2B2C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2777 7.08325L18.6666 4.99991",
    stroke: "#2B2B2C",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaskBuss);
export default __webpack_public_path__ + "static/media/VaskBuss.6b0d63da4b0cf14877f25e4b13f0005c.svg";
export { ForwardRef as ReactComponent };